import { useTranslation } from 'react-i18next'
import { ColumnsType } from 'antd/lib/table'
import { OverallMargin, TeamMargin } from 'modules/domain/teams/types'
import { generatePath } from 'react-router-dom'
import TeamsRoutes from 'views/pages/Teams/routes'
import formatNumber from 'modules/utils/numbers/formatNumber'
import { useMemo } from 'react'
import env from 'env'
import { TeamsProgress } from 'views/components/TeamsProgress/TeamsProgress'
import { TableTextLink } from 'views/ui/TableTextLink/TableTextLink'

const currency = env.REACT_APP_CURRENCY_SYMBOL

export const useTeamColumns = (): ColumnsType<TeamMargin> => {
  const { t } = useTranslation('teams')

  return useMemo(
    () => [
      {
        title: t('team'),
        dataIndex: 'team_name',
        key: 'team_name',
        width: '138px',
        render: (teamName, data) => (
          <TableTextLink id="team" to={generatePath(TeamsRoutes.Details, { id: data.team_id })} key={data.team_id}>
            {teamName}
          </TableTextLink>
        ),
      },
      {
        title: t('monthly_plan', { currency }),
        dataIndex: 'margins',
        key: 'margins_planned_margin',
        align: 'right',
        width: '122px',
        render: (margins: OverallMargin) => formatNumber(margins.planned_margin),
      },
      {
        title: t('month_results', { currency }),
        dataIndex: 'margins',
        key: 'margins_margin',
        align: 'right',
        width: '155px',
        render: (margins: OverallMargin) => (
          <TeamsProgress align="flex-end" isTableCell margin={margins.margin} planned_margin={margins.planned_margin} />
        ),
      },
    ],
    [t],
  )
}
